import React from "react";
import DoctorAppointment from "./DoctorAppointment";

const AppointmentList = () => {
  return (
    <>
      <div className=" mt-4">
        <div className="tab-content" id="v-pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="v-pills-hospital-1"
            role="tabpanel"
            aria-labelledby="v-pills-hospital-1-tab"
          >
            <DoctorAppointment />
          </div>
          <div
            className="tab-pane fade"
            id="v-pills-hospital-2"
            role="tabpanel"
            aria-labelledby="v-pills-hospital-2-tab"
          >
            <DoctorAppointment />
          </div>
          <div
            className="tab-pane fade"
            id="v-pills-hospital-3"
            role="tabpanel"
            aria-labelledby="v-pills-hospital-3-tab"
          >
            <DoctorAppointment />
          </div>
          <div
            className="tab-pane fade"
            id="v-pills-hospital-4"
            role="tabpanel"
            aria-labelledby="v-pills-hospital-4-tab"
          >
            <DoctorAppointment />
          </div>
        </div>
      </div>
    </>
  );
};

export default AppointmentList;
